// src/Components/conferencePages/Committees.js
import React from "react";
import styles from "./Committees.module.css";
import { FaCheck } from "react-icons/fa";
import { GoGlobe } from "react-icons/go";
import { RiGroupLine } from "react-icons/ri";
import { MdOutlineLocalPolice } from "react-icons/md";
import { FaMicrophone } from "react-icons/fa6";
import { IoStar } from "react-icons/io5";
import { GrTechnology } from "react-icons/gr";
import { MdAssistant } from "react-icons/md";

export default function Committees() {
  return (
    <div className={styles.container}>
      {/* Conference Chair */}
      <div>
        <div className={styles.cont1}>
          <span className={styles.icon1}>
            <IoStar
              style={{ display: "inline", marginTop: "4px" }}
              size={28}
              fill="white"
            />
          </span>
          <span className={styles.right}>
            <h1 className={styles.heading}>Conference Coordinator</h1>{" "}
          </span>
        </div>

        <ul style={{marginBottom:'20px'}}>
          <li className={styles.listcont}>
            <span className={styles.listicon2}>
              <FaCheck color="green" size={18} style={{marginTop:'25px'}} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. J. Uthayakumar, Professor/CSE, Idhaya Engineering College for Women.</p>
            </span>
          </li>
        </ul>
       
      </div>

      <div>
        <div className={styles.cont1}>
          <span className={styles.icon1}>
            <MdAssistant
              style={{ display: "inline", marginTop: "4px" }}
              size={28}
              fill="white"
            />
          </span>
          <span className={styles.right}>
            <h1 className={styles.heading}>Conference Co-Coordinator</h1>{" "}
          </span>
        </div>

        <ul style={{marginBottom:'20px'}}>
          <li className={styles.listcont}>
            <span className={styles.listicon2}>
              <FaCheck color="green" size={18} style={{marginTop:'25px'}} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Prof. S. Jayaprakash, Head/CSE, Idhaya Engineering College for Women.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon2}>
              <FaCheck color="green" size={18} style={{marginTop:'25px'}} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. D. Revati, Associate Professor/EEE, Idhaya Engineering College for Women.</p>
            </span>
          </li>
        </ul>
       
      </div>

      {/* Session Chair */}
      <div>
        <div className={styles.cont2}>
          <span className={styles.icon2}>
            <FaMicrophone
              style={{ display: "inline", marginTop: "4px" }}
              size={28}
              fill="white"
            />
          </span>
          <span className={styles.right}>
            <h1 className={styles.heading}>Session Coordinator</h1>{" "}
          </span>
        </div>

        <ul style={{marginBottom:'6rem'}}>
          <li className={styles.listcont}>
            <span className={styles.listicon2}>
              <FaCheck color="green" size={18} style={{marginTop:'25px'}}/>
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. S. Sathiamoorthy (Head i/c) PG Extension Centre, Annamalai University.</p>
            </span>
          </li>
        </ul>
      
      </div>

      {/* International Advisory Committee */}
      <section className={styles.section1}>
        <div className={styles.cont}>
          <span className={styles.icon}>
            <GoGlobe
              style={{ display: "inline", marginTop: "4px" }}
              size={28}
              fill="white"
            />
          </span>
          <span className={styles.right}>
            <h1 className={styles.heading}>International Advisory Committee</h1>{" "}
            <br />
            <p className={styles.para}>Global Expertise and Guidance</p>
          </span>
        </div>
        <ul>
          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. M.S.Saleem Basha</p>
              <p className={styles.listpara}>University of Buraimi, Oman.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. J. Amudhavel Jayavel</p>
              <p className={styles.listpara}>De Montfort University, Europe.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. A. Saahira Banu</p>
              <p className={styles.listpara}>
                Jazan University, Kingdom of Saudi Arabia.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. Naseema Shaik</p>
              <p className={styles.listpara}>
                 King Khalid University, Abha.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. Yu-Chen Hu</p>
              <p className={styles.listpara}>
                Tunghai University, Taiwan.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. Thushara Hameed</p>
              <p className={styles.listpara}>
                University of Technology and Applied science, Nizwa.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. Vinayakumar Ravi</p>
              <p className={styles.listpara}>
                Prince Mohammad Bin Fahd University, Khobar.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. Salahddine Krit</p>
              <p className={styles.listpara}>
                Ibnzohr University, Morocco.
              </p>
            </span>
          </li>
        </ul>
      </section>

      {/* National Advisory Committee */}
      <section className={styles.section2}>
        <div className={styles.cont}>
          <span className={styles.icon}>
            <RiGroupLine
              style={{ display: "inline", marginTop: "4px" }}
              size={28}
              fill="white"
            />
          </span>
          <span className={styles.right}>
            <h1 className={styles.heading}>National Advisory Committee</h1>{" "}
            <br />
            <p className={styles.para}>National Leadership and Oversight</p>
          </span>
        </div>
        <ul>
          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. T. Vengattaraman</p>
              <p className={styles.listpara}>Pondicherry University.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. P. Ezhumalai</p>
              <p className={styles.listpara}>RMD Engineering College.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. Pothula Sujatha</p>
              <p className={styles.listpara}>Pondicherry University.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. A. Martin</p>
              <p className={styles.listpara}>Central University of Tamilnadu.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. P. Sudhakar</p>
              <p className={styles.listpara}>Annamalai University.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. R. Rajakumar</p>
              <p className={styles.listpara}>VIT, Chennai Campus.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. Chinnarao Kurangi</p>
              <p className={styles.listpara}>GITAM Deemed to be University.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. T. Suresh</p>
              <p className={styles.listpara}>Annamalai University.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. M. Anousouya Devi</p>
              <p className={styles.listpara}>SRM University.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. Sivadi Balakrishna</p>
              <p className={styles.listpara}>Vignan University.</p>
            </span>
          </li>
        </ul>
      </section>

      {/* Local Advisory Committee */}
      <section className={styles.section3}>
        <div className={styles.cont}>
          <span className={styles.icon}>
            <MdOutlineLocalPolice
              style={{ display: "inline", marginTop: "4px" }}
              size={28}
              fill="white"
            />
          </span>
          <span className={styles.right}>
            <h1 className={styles.heading}>Local Advisory Committee</h1> <br />
            <p className={styles.para}>
              Community Engagement and Localized Insight
            </p>
          </span>
        </div>
        <ul>
          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Prof. K. Gandhimathi</p>
              <p className={styles.listpara}>
                Idhaya Engineering College for Women.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. A. Sariga</p>
              <p className={styles.listpara}>
                Idhaya Engineering College for Women.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Mrs. S. Dhanalakshmi</p>
              <p className={styles.listpara}>
                Idhaya Engineering College for Women.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. J. Madhusudanan</p>
              <p className={styles.listpara}>
                Sri Manakula Vinayagar Engineering College.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. P. Sivakumar</p>
              <p className={styles.listpara}>
                Manakula Vinayagar Institute of Technology.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. T. Priyaradhikadevi</p>
              <p className={styles.listpara}>Mailam Engineering College.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. C. Dhaya</p>
              <p className={styles.listpara}>
                Adhiparasakthi Engineering College.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. S. Famila</p>
              <p className={styles.listpara}>Vel Tech University.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Dr . S. Leones Sherwin Vimalraj
              </p>
              <p className={styles.listpara}>Panimalar Engineering College.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. E. Ranjith</p>
              <p className={styles.listpara}>Takshashila University.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. S. Sridevi</p>
              <p className={styles.listpara}>
                Achariya College of Engineering Technology.
              </p>
            </span>
          </li>
        </ul>
      </section>

      {/* Technical Advisory Committee */}
      <section className={styles.section4}>
        <div className={styles.cont}>
          <span className={styles.icon}>
            <GrTechnology
              style={{ display: "inline", marginTop: "4px" }}
              size={30}
              fill="white"
              color="white"
            />
          </span>
          <span className={styles.right}>
            <h1 className={styles.heading}>Technical Advisory Committee</h1> <br />
            <p className={styles.para}>
              Specialized Knowledge and Technical Expertise
            </p>
          </span>
        </div>
        <ul>
          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Dr. K. Suresh Joseph
              </p>
              <p className={styles.listpara}>Pondicherry University.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. M. Kamarasan</p>
              <p className={styles.listpara}>
                Annamalai University.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. S.P. Balamurugan</p>
              <p className={styles.listpara}>
                Annamalai University.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. G. Kadiravan</p>
              <p className={styles.listpara}>
                AMC Institutions.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. H. Anwer Basha</p>
              <p className={styles.listpara}>Raak Arts & Science College.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. R. Anandkumar</p>
              <p className={styles.listpara}>
                Sri Manakula Vinayagar Engineering College.
              </p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>Dr. A. Meiappane</p>
              <p className={styles.listpara}>Manakula Vinayagar Institute of Technology.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Ms. A. Punitha
              </p>
              <p className={styles.listpara}>Manakula Vinayagar Institute of Technology.</p>
            </span>
          </li>

          <li className={styles.listcont}>
            <span className={styles.listicon}>
              <FaCheck color="green" size={18} />
            </span>
            <span className={styles.listright}>
              <p className={styles.listheading}>
                Mr. J. Ravikumar
              </p>
              <p className={styles.listpara}>Machine Learning Engineer, Genesys Academy.</p>
            </span>
          </li>

        </ul>
      </section>
    </div>
  );
}
